import type { Client, LabelAndIcon } from '@base/types';

export const CLIENT_NAMES = [
  'discord',
  'twitter',
  'telegram',
  'direct',
  'farcaster',
  'lens',
  'auto',
  'slack',
  'github',
] as const;

export const CLIENTS_MAP: Record<Client, LabelAndIcon> = {
  discord: {
    label: 'Discord',
    icon: '',
  },
  twitter: {
    label: 'X (Twitter)',
    icon: '',
  },
  telegram: {
    label: 'Telegram',
    icon: '',
  },
  direct: {
    label: 'Direct',
    icon: '',
  },
  farcaster: {
    label: 'Farcaster',
    icon: '',
  },
  lens: {
    label: 'Lens',
    icon: '',
  },
  auto: {
    label: 'Auto',
    icon: '',
  },
  slack: {
    label: 'Slack',
    icon: '',
  },
  github: {
    label: 'Github',
    icon: '',
  },
};

export const SECRETS_CLIENT_MAP: Record<Client, Record<string, string>> = {
  discord: {
    DISCORD_API_TOKEN: '',
    DISCORD_APPLICATION_ID: '',
  },
  twitter: {
    TWITTER_USERNAME: '',
    TWITTER_PASSWORD: '',
    TWITTER_EMAIL: '',
    TWITTER_2FA_SECRET: '',
    POST_IMMEDIATELY: 'true',
    ENABLE_ACTION_PROCESSING: 'true',
    MAX_ACTIONS_PROCESSING: '10',
    POST_INTERVAL_MAX: '180',
    POST_INTERVAL_MIN: '90',
    TWITTER_SPACES_ENABLE: 'false',
    ACTION_TIMELINE_TYPE: 'foryou',
    TWITTER_POLL_INTERVAL: '120',
  },
  telegram: { TELEGRAM_BOT_TOKEN: '' },
  direct: {},
  farcaster: {
    FARCASTER_NEYNAR_API_KEY: '',
    FARCASTER_FID: '',
    FARCASTER_NEYNAR_SIGNER_UUID: '',
  },
  lens: {
    EVM_PRIVATE_KEY: '',
    LENS_PROFILE_ID: '',
    EVM_PROVIDER_URL: 'https://ethereum-rpc.publicnode.com',
  },
  auto: {},
  slack: {
    SLACK_TOKEN: '',
    SLACK_APP_ID: '',
    SLACK_CLIENT_ID: '',
    SLACK_CLIENT_SECRET: '',
    SLACK_SIGNING_SECRET: '',
    SLACK_BOT_TOKEN: '',
    SLACK_VERIFICATION_TOKEN: '',
  },
  github: {
    GITHUB_OWNER: '',
    GITHUB_REPO: '',
    GITHUB_BRANCH: '',
    GITHUB_PATH: '',
    GITHUB_API_TOKEN: '',
  },
};
